module.exports = ".products{ border: none; }"